var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiData1 = function SvgAiData1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 84 85"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    y: 0.857,
    fill: "#204969",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M54.34 46.81c-8.805 2.908-11.738 5.841-14.647 14.647-.24.724-1.263.724-1.502 0-2.91-8.806-5.843-11.738-14.648-14.648-.724-.24-.724-1.263 0-1.502 8.806-2.91 11.738-5.843 14.648-14.648.24-.724 1.263-.724 1.502 0 2.91 8.806 5.842 11.738 14.648 14.648.724.24.724 1.263 0 1.502M60.729 32.348c-4.402 1.453-5.87 2.92-7.325 7.325-.12.361-.63.361-.751 0-1.454-4.403-2.922-5.87-7.325-7.325-.362-.12-.362-.63 0-.752 4.401-1.453 5.869-2.92 7.325-7.324.118-.362.63-.362.75 0 1.454 4.402 2.922 5.869 7.325 7.324.362.12.362.63 0 .752"
  })));
};
export default SvgAiData1;